import { Box, Button, CircularProgress, FormControl, Menu, MenuItem, Select, TextField } from '@mui/material';
import React, { useState } from 'react'
import Page from '../../component/Page';
import { REPORT_CONFIG } from './config';
import api from '../../api/api'
import { saveAs } from 'file-saver';
import RequireSelect from '../../component/RequireSelect';
export default function ReportPlanReview() {

    const [y, setY] = useState(new Date().getFullYear() + 543)
    const [s, setS] = useState('')
    const [v, setV] = useState('')
    const [reports, setReports] = useState([])
    const [loadingDownload, setloadingDownload] = useState(false);
    const [loading, setloading] = useState(false);
    const [Error, setError] = useState(false);

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        if (s.length === 0) {
            setError(true)
        } else {
            setAnchorEl(event.currentTarget);

        }
    };
    const handleClose = () => {
        setAnchorEl(null);
    };


    const seasons = [
        {
            value: 'แล้ง'
        },
        {
            value: 'ฝน'
        }
    ]

    const version = ['1', '2', '3', '4', '5'];

    async function getReportPlanReview(body, mode, format) {

        const url = `${REPORT_CONFIG.requests.getReportPlanReview.url}/${mode}`;


        let _params = '';
        let _y = '';
        let _s = '';
        let _v = '';

        let _format = '';



        if (body.y) {
            _y = 'y=' + body.y;
        }

        if (body.s) {
            _s = '&s=' + (body.s !== '-' ? body.s : '');
        }
        if (body.v) {
            _v = '&version=' + body.v;
        }


        if (format) {
            _format = '&format=' + format;
        }
        _params = '?' + _y + _s + _v + _format
        if (mode === 'file') {
            setloadingDownload(true)
            const res = await api.get(url + _params, { responseType: 'arraybuffer' })
            const data = res.data
            if (format) {
                const blob = new Blob([data], { type: 'application/pdf' });
                saveAs(blob, 'รายงานศักยภาพและแผนผลิตเมล็ดพันธุ์ข้าวประจำปี (ทบทวน) (กมข-30401)');

            } else {
                const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(blob, 'รายงานศักยภาพและแผนผลิตเมล็ดพันธุ์ข้าวประจำปี (ทบทวน) (กมข-30401)');
            }
            setloadingDownload(false)
        } else {
            setloading(true)
            const res = await api.get(url + _params)
            const data = res.data.result
            setReports(data)
            setloading(false)
        }

    }
    async function LoadReport(e) {
        e.preventDefault()
        const body = {
            y: y,
            s: s || undefined,
            version: v === 'all' ? '' : v
        };
        if (s.length === 0) {
            setError(true)
        } else {
            getReportPlanReview(body, 'data');
        }

    }
    return (
        <div style={{ padding: '10px 30px' }}>
            <Page>
                <div class="container-fluid p-0">
                    <form onSubmit={e => LoadReport(e)}>
                        <div class="row  no-gutters">

                            <div class="col-12 col-lg-2">
                                <div class="row no-gutters">
                                    <div class="col-12 header-row border-1 ">
                                        ตัวกรอง
                                    </div>
                                </div>
                                <div class="row no-gutters p-2 border-1">
                                    <div class="col-12">

                                        <label class="labelInput">ปี</label>

                                        <Box className='backgroundField'>
                                            <TextField value={y} onChange={e => setY(e.target.value)} variant="standard" fullWidth
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                            />
                                        </Box>
                                    </div>

                                    <div class="col-12" style={{ margin: '10px 0' }}>
                                        <label class="labelInput">ฤดู</label>
                                        <RequireSelect value={s || '-'} onChange={setS} menu={seasons?.map((x, i) => (
                                                <MenuItem key={i} value={x?.value}>{x?.value}</MenuItem>
                                            ))} disabled={false} error={Error} setError={setError} textError={'กรุณาเลือกฤดู'} />

                                    </div>
                                    <div class="col-12">
                                        <label class="labelInput">ครั้งที่</label>

                                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                            <FormControl variant="standard" fullWidth >
                                                <Select value={v || 'all'} onChange={e => setV(e.target.value)} disableUnderline >
                                                    <MenuItem value='all'>ทั้งหมด</MenuItem>
                                                    {version?.map((x) => (
                                                        <MenuItem value={x}>{x}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </div>
                                    <div class="col-12">
                                        <Button onClick={LoadReport} disabled={loading ? true : false} variant='contained' className="ButtomSearch">{loading ? <CircularProgress size={'18px'} color="inherit" /> : 'ค้นหา'} </Button>
                                    </div>

                                </div >
                            </div >
                            <div class="col-12 col-lg-10">
                                <div class="row no-gutters">
                                    <div class="col-12 d-flex justify-content-between header-row border-1 ">
                                        <div>
                                            รายงานศักยภาพและแผนผลิตเมล็ดพันธุ์ข้าวประจำปี (ทบทวน) (กมข-30401)
                                        </div>
                                        <Button variant='contained'
                                            id="basic-button"
                                            aria-controls={open ? 'basic-menu' : undefined}
                                            aria-haspopup="true"
                                            aria-expanded={open ? 'true' : undefined}
                                            disabled={loadingDownload ? true : false}
                                            onClick={handleClick}>{loadingDownload ? <CircularProgress size={'18px'} color="inherit" /> : 'ดาวน์โหลด'}</Button>
                                        <Menu
                                            id="basic-menu"
                                            anchorEl={anchorEl}
                                            open={open}
                                            onClose={handleClose}
                                            MenuListProps={{
                                                'aria-labelledby': 'basic-button',
                                            }}
                                            PaperProps={{  
                                                style: {  
                                                  width: 100,  
                                                },
                                            }}
                                        >
                                            <MenuItem onClick={() => {
                                                const body = {
                                                    y: y,
                                                    s: s || undefined,
                                                    version: v === 'all' ? '' : v
                                                };
                                                // setFormat('')
                                                getReportPlanReview(body, 'file')

                                                handleClose()
                                            }}>Excel</MenuItem>
                                            <MenuItem onClick={() => {
                                                const body = {
                                                    y: y,
                                                    s: s || undefined,
                                                    version: v === 'all' ? '' : v
                                                };
                                                // setFormat('pdf')
                                                getReportPlanReview(body, 'file', 'pdf')

                                                handleClose()
                                            }}>Pdf</MenuItem>
                                        </Menu>
                                    </div >

                                </div >
                                <div class="text-end " style={{ color: 'red' }}>
                                    ( หน่วย : ตัน )
                                </div>
                                <div class="row no-gutters border-1 pt-3">
                                    <div class="report col-12">
                                        <div class="table-responsive-sm" style={{ height: "auto" }}>
                                            <table class="table table-sm  table-hover">
                                                <thead class="sticky-thead">
                                                    <tr>
                                                        <th scope="col">ที่</th>
                                                        <th scope="col">ศูนย์เมล็ดพันธุ์ข้าว</th>
                                                        <th scope="col">ประเภทข้าว</th>
                                                        <th scope="col">พันธุ์</th>
                                                        <th scope="col">ฤดู</th>
                                                        <th scope="col">เป้าหมายการผลิต (เดิม)</th>
                                                        <th scope="col">เป้าหมายการผลิต (ใหม่)</th>
                                                        <th scope="col">เหตุผลประกอบ </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {reports?.map((report, i) => (
                                                        <tr class="cp">
                                                            <td class="text-center">{i + 1}</td>
                                                            <td class="text-center">{report.BranchName}</td>
                                                            <td class="text-center">{report.GroupName}</td>
                                                            <td class="text-center">{report.CatalogName}</td>
                                                            <td class="text-center">{report.Season}</td>
                                                            <td class="text-center">{parseFloat(report.InitialTarget / 1000).toFixed(3)
                                                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                                            <td class="text-center">{parseFloat(report.UpdateTarget / 1000).toFixed(3)
                                                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                                            <td class="text-center">{report.Reason}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                {
                                    reports.length === 0 &&
                                    <div class="row" >
                                        <div class="col-12">
                                            <div class="not-found">
                                                ไม่พบข้อมูล
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div >

                        </div >

                    </form >
                </div >
            </Page >
        </div >
    )
}
